import debounce from 'lodash.debounce';
import { useLazyQuery } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';

import {
  AUTOCOMPLETION_DEFAULT_DEBOUNCE_TIME_MS,
  AUTOCOMPLETION_ITEMS_DEFAULT_LIMIT,
  AUTOCOMPLETION_CONSUMER,
} from '../constants';

import LOCATION_SUGGESTIONS_QUERY from './locationSuggestionsQuery.graphql';

export const useLocationAutocompletion = (
  limit = AUTOCOMPLETION_ITEMS_DEFAULT_LIMIT,
  debounceTime = AUTOCOMPLETION_DEFAULT_DEBOUNCE_TIME_MS
) => {
  const [locationSuggestions, setLocationSuggestions] = useState([]);
  const [getSuggestions, { data, loading, called }] = useLazyQuery(
    LOCATION_SUGGESTIONS_QUERY
  );

  const fetchLocationSuggestions = useMemo(
    () =>
      debounce(query => {
        getSuggestions({
          variables: {
            consumer: AUTOCOMPLETION_CONSUMER,
            text: query,
            language: 'en',
          },
        });
      }, debounceTime),
    [debounceTime, getSuggestions]
  );

  useEffect(() => {
    if (!loading && called) {
      const collection =
        data && data.autocompletionLocationsCity
          ? data.autocompletionLocationsCity.collection
          : [];
      const suggestions =
        collection && collection.length > 0
          ? collection
              .slice(0, limit)
              .reduce((acc, { name }) => (name ? [...acc, name] : acc), [])
          : [];

      setLocationSuggestions(suggestions);
    }
  }, [loading, data, limit]);

  return { locationSuggestions, fetchLocationSuggestions };
};
